import * as _ from 'lodash-es';

/**
 * Get grouped fields from @param fields when @param isGroupFields is set to true
 * @param fields
 * @param isGroupFields
 */
export function getGroupedFields(fields: string[], isGroupFields: boolean) : any {
  let groupedKeys : any = {"all": {"keys": []}};
  if (isGroupFields) {
    _.forEach(fields, function (key, index) {
      if (_.includes(key, ".")) {
        let field = _.split(key, ".");
        if (!groupedKeys[field[0]]) {
          groupedKeys[field[0]] = {"keys": []};
        }
        groupedKeys[field[0]].keys.push({"title": _.replace(key, field[0] + ".", ""), "index": index, "key": key});
      } else {
        groupedKeys.all.keys.push({"title": key, "index": index, "key": key});
      }
    });
  } else {
    groupedKeys.all.keys = groupedKeys.all.keys.concat(_.map(fields, (key, index) => {
      return {"title": key, "index": index, "key": key};
    }));
  }
  return groupedKeys;
}
